import {FileTypes} from "@/ts/enums/FileTypes";
import {FolderTypeApi} from "@/ts/enums/FolderTypeApi";

export default {
    state: {
        dialogVisible: false,
        files: [],
        fileType: ""
    },
    show(folderType: string) {
        this.state.dialogVisible = true;
        switch (folderType) {
            case FolderTypeApi.PARENT:
                //This type of folder has no option to open a File Dialog
                break;
            case FolderTypeApi.FORMULAR:
            case FolderTypeApi.LEISTUNG:
            case FolderTypeApi.LEISTUNG_OHNE_PREISE:
            case FolderTypeApi.DOCUMENTATION:
                this.state.fileType = FileTypes.PDF;
                break;
            case FolderTypeApi.IMAGE:
                this.state.fileType = FileTypes.IMAGES;
                break;
            case FolderTypeApi.FREE:
                this.state.fileType = FileTypes.ALL;
                break;
        }
    },
    dismiss() {
        this.state.dialogVisible = false;
        this.state.files = []
    }
}
